<app-shared-dialog
  [title]="dialogTitle"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="label-form-dialog__body">
    <!-- A provider_sync label's name and description are read-only: the backend
         answers 400 to either edit. Rendered as static text rather than a disabled
         input, so there is no control to reach at all. Its colour is NOT locked —
         the backend accepts that on the same record, deliberately. -->
    <div class="label-form-dialog__provider-hint" *ngIf="isProviderSynced">
      {{ 'settings.label_provider_readonly' | translate }}
    </div>

    <ng-container *ngIf="isProviderSynced; else editableIdentity">
      <div class="label-form-dialog__readonly">
        <span class="label-form-dialog__label">{{ 'settings.label_name' | translate }}</span>
        <span class="label-form-dialog__readonly-value" data-testid="label-name-readonly">
          {{ labelNameControl.value }}
        </span>
      </div>

      <div class="label-form-dialog__readonly">
        <span class="label-form-dialog__label">{{ 'settings.label_description' | translate }}</span>
        <span class="label-form-dialog__readonly-value" data-testid="label-description-readonly">
          {{ labelDescriptionControl.value || '--' }}
        </span>
      </div>
    </ng-container>

    <ng-template #editableIdentity>
      <ui-form-field
        data-testid="label-name-field"
        [formControl]="labelNameControl"
        [placeholder]="'settings.label_name' | translate"
        [errorMessages]="{ required: 'validation.required' | translate }">
      </ui-form-field>

      <ui-form-field
        type="textarea"
        data-testid="label-description-field"
        [formControl]="labelDescriptionControl"
        [placeholder]="'settings.label_description' | translate">
      </ui-form-field>
    </ng-template>

    <!-- A fixed palette, not free hex entry. The API accepts any #RRGGBB, but a
         palette keeps chips legible and stops a user picking white on white. -->
    <div class="label-form-dialog__colors">
      <span class="label-form-dialog__label">{{ 'settings.label_color' | translate }}</span>
      <div class="label-form-dialog__swatches">
        <button
          *ngFor="let color of palette; trackBy: trackByColor"
          type="button"
          class="label-form-dialog__swatch"
          [class.label-form-dialog__swatch--selected]="isColorSelected(color)"
          [attr.aria-pressed]="isColorSelected(color)"
          [attr.aria-label]="color"
          [style.background]="color"
          (click)="selectColor(color)"></button>
      </div>
    </div>

    <!-- Edit only. The create endpoint does not accept these two flags -- its DTO
         does not declare them and extra='ignore' drops them -- so at create they
         would be switches that appear to work and change nothing. A new label
         lands visible and eligible; governance is set on the next edit. -->
    <div class="label-form-dialog__governance" *ngIf="isEditMode">
      <div class="label-form-dialog__switch label-form-dialog__visible">
        <mat-slide-toggle color="primary" [formControl]="visibleControl">
          {{ 'settings.label_visible' | translate }}
        </mat-slide-toggle>
        <span class="label-form-dialog__hint">{{ 'settings.label_visible_hint' | translate }}</span>
      </div>

      <!-- The eligible-but-hidden pair is a 400 from the backend, so it is made
           unreachable here rather than error-handled: while `visible` is off this
           control is disabled and its value forced to false. -->
      <div class="label-form-dialog__switch label-form-dialog__eligible">
        <mat-slide-toggle color="primary" [formControl]="eligibleControl">
          {{ 'settings.label_eligible' | translate }}
        </mat-slide-toggle>
        <span
          class="label-form-dialog__hint"
          *ngIf="!visibleControl.value"
          data-testid="label-eligible-hint">
          {{ 'settings.label_eligible_hint' | translate }}
        </span>
      </div>
    </div>
  </div>

  <div customConfirm>
    <ui-button
      type="primary"
      [label]="saveLabel | uppercase"
      [icon]="isEditMode ? 'pen-cc' : 'plus-cc'"
      iconPosition="start"
      [isLoading]="isSubmitting"
      [disabled]="isFormInvalid || isSubmitting"
      (click)="submitForm()">
    </ui-button>
  </div>
</app-shared-dialog>
